import { Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

function HomeWholesale() {
  return (
    <section>
      <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <Typography className="mb-4 text-4xl tracking-tight font-extrabold text-gray-900">
          Wholesale Natural Stone for Landscaping Distributors — Since 1993
        </Typography>
        <Typography variant="body1" marginBottom={2}>
          Direct from China and other origins to your designated location.
          We process and deliver to meet our clients&apos; requirements.
        </Typography>
        <Typography variant="body1" marginBottom={2}>
          We supply landscaping wholesalers and distributors in Europe,
          North America, and other markets.
        </Typography>
        <Typography variant="body1" marginBottom={2}>
          Headquartered in China, with Canada-based service. That means
          24-hour business service for overseas customers — no time-zone
          gap, and no language barrier.
        </Typography>
        <Typography variant="body1" marginBottom={2}>
          Since 1993, Ming Stone has exported natural stone with
          professional foreign-trade experience. We supply stone by colour,
          stone type, and processing method, according to each
          customer&apos;s design requirements, cut to size.
        </Typography>
        <Typography variant="body1" marginBottom={2}>
          We process to meet clients&apos; finish requirements. See our
          shared{" "}
          <Link to="/products/processing" className="underline">
            Processing
          </Link>{" "}
          page for the full finishes list. If you need a finish not listed
          there, send us a photo and we will have the factory process it
          to match.
        </Typography>
        <Typography variant="h6" component="h2" className="mt-6 mb-2">
          How ordering works
        </Typography>
        <ol className="list-decimal ml-6 space-y-1 mb-4">
          <li>
            Send an enquiry with product code / colour, processing, size,
            and quantity.
          </li>
          <li>
            We quote based on colour, stone type, processing, size,
            quantity, and destination.
          </li>
          <li>
            We process and deliver to meet our clients&apos; requirements.
            Goods are shipped directly from China or other origins to your
            designated location.
          </li>
        </ol>
        <Typography variant="body1" marginBottom={2}>
          Preferred minimum order: one full container, FCL 20&apos;
          container. LCL (consolidated) shipment can be discussed if the
          customer agrees to the additional cost. Prices are on request,
          because they vary by colour and processing requirements.
        </Typography>
        <Box className="flex flex-wrap gap-4 mt-4">
          <Button component={Link} to="/products" variant="contained" color="brand">
            View Products
          </Button>
          <Button component={Link} to="/contact" variant="outlined" color="brand">
            Request Quote
          </Button>
        </Box>
      </div>
    </section>
  );
}

export default HomeWholesale;
